import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Col, Card, Typography } from "antd";

import CustomTitle from "../../app/generic/customTitle";

const { Text } = Typography;

const Tab = ({ contract, onClick }) => {
  const [inside, setInside] = useState();
  const handleShowNagination = useCallback(() => {
    setInside(true);
  }, []);
  const handleHideNagination = useCallback(() => {
    setInside(false);
  }, []);

  return (
    <Row justify="center">
      <Col className="center">
        <Card
          onClick={onClick}
          onMouseEnter={handleShowNagination}
          onMouseLeave={handleHideNagination}
          className={`pointer ${inside ? "yellow-border" : ""}`}
        >
          {contract ? (
            contract.sent ? (
              <CustomTitle
                level={2}
                id="registration.sent"
                defaultMessage="Odeslaná registrace"
              />
            ) : (
              <CustomTitle
                level={2}
                id="registration.old"
                defaultMessage="Nová registrace"
              />
            )
          ) : (
            <CustomTitle
              level={2}
              id="registration.new"
              defaultMessage="Rozpracovaná registrace"
            />
          )}
          <Text strong>
            {contract ? (
              contract.sent ? (
                <FormattedMessage
                  id="registration.description.sent"
                  defaultMessage="Prohlédnout odeslanou registraci"
                />
              ) : (
                <FormattedMessage
                  id="registration.description.old"
                  defaultMessage="Pokračovat v rozpracované registraci"
                />
              )
            ) : (
              <FormattedMessage
                id="registration.description"
                defaultMessage="Registrace nového klienta"
              />
            )}
          </Text>
        </Card>
      </Col>
    </Row>
  );
};

export default Tab;
